import React from 'react';
import { colors } from '@noths/polaris-client-ribbons-base';
import { IconWarning } from '@noths/polaris-client-ribbons-design-system';

import * as styles from 'src/styles/styles';
import { SECTION_ERROR_LINE } from './copy';

export const ErrorMessage = () => (
  <div css={styles.errorField} role="alert">
    <IconWarning color={colors.neutralDarker} css={styles.errorIcon} />
    <p>{SECTION_ERROR_LINE}</p>
  </div>
);
